module.exports = __webpack_public_path__ + "static/media/points8_8.cfd3a537.png";